import React, { useCallback, useEffect, useState } from "react";
import { Button, Timeline, Typography } from "antd";
import "./rolesandpermissions.scss";
import { CloseButton } from "./constant";
import { roleandpermissions } from "../../services";
import { AppModal } from "../../components/common";

const { Text, Paragraph } = Typography;

const RolesAndPermissionsLogs = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [logs, setLogs] = useState<any>([]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const getLogs = useCallback(() => {
    roleandpermissions
      .getAllLogs()
      .then((res: any) => {
        setLogs(res?.data?.logs || []);
      })
      .catch((err: any) => {});
  }, []);

  useEffect(() => {
    if (isModalOpen) {
      getLogs();
    }
  }, [isModalOpen, getLogs]);

  return (
    <>
      <Button
        onClick={showModal}
        iconPosition="end"
        icon={<img src="/logs.png" alt="log" width={24} height={24} />}
        className="logs_btn"
      >
        Logs
      </Button>
      <AppModal
        className="logsModal"
        title={"Roles & Permissions Logs"}
        open={isModalOpen}
        onCancel={handleCancel}
      >
        <div className="log-container">
          <Timeline className="custom-timeline">
            {logs?.map((log: any) => (
              <Timeline.Item
                color="gray"
                key={log?._id}
                className={`timeline-item`}
              >
                <div className="log-card">
                  <Text strong className="log-date">
                    {new Date(log?.updatedAt).toLocaleString("en-IN", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                      hour: "numeric",
                      minute: "2-digit",
                      hour12: true,
                      timeZoneName: "short",
                    })}
                  </Text>
                  <Paragraph className="log-details">
                    <Text className="log-action">{log?.action}: </Text>
                    <Text className="log-user">{log?.email}</Text>
                  </Paragraph>
                  <Paragraph>
                    <Text className="log-action">Role: </Text>
                    <Text className="log-user capitalize">
                      {log?.role?.replace(/_/g, " ")}
                    </Text>
                  </Paragraph>
                  <Paragraph>
                    <Text className="log-action">Actioned by: </Text>
                    <Text className="log-user">Super Admin</Text>
                  </Paragraph>
                </div>
              </Timeline.Item>
            ))}
          </Timeline>
        </div>
      </AppModal>
    </>
  );
};

export default RolesAndPermissionsLogs;
